import { CUISINE_DATA } from '../../../../../constants/progressBanner'
import { CategoryData } from './types'

export const adaptCuisineData = (): CategoryData => {
    const adaptedData: CategoryData = {}

    Object.entries(CUISINE_DATA).forEach(([category, items]) => {
        adaptedData[category] = items.map(item => ({
            name: item.name,
            id: item.genreId,
        }))
    })

    return adaptedData
}
